export default "__VITE_ASSET__kUTXvwZf__"